module.exports = __webpack_public_path__ + "media/reference2.b731f347.mp3";